import React, {Component} from 'react';
import './IEnergy.css';
import IndustryIndividualCard from '../Components/IndustryIndividualCard/IndustryIndividualCard.js'
import energyCover from '../../../images/individual/energy/EnergyCover.jpeg';
import oil from '../../../images/individual/energy/Oil.jpg';
import energy from '../../../images/individual/energy/Energy.jpg';

export default class IEnergy extends Component {
	render() {
		return (
			<div className="i_energy_container">
				<div className="i_energy_container_cover_text">ENERGY, OIL & GAS</div>
				<div className="i_energy_container_cover_image"><img src={energyCover} /></div>
				<div className="i_energy_subtitle">
					<span>PPI has an unparalleled ability to make a significant and positive impact in Asia-Pacific through its world class investment management team.</span>
				</div>
				<div className="i_energy_content">
				<IndustryIndividualCard
					link = '#'
					clickable={false}
					image={energy}
					title='RENEWABLE ENERGY'
					description1='PPI’s involvement in renewable energy projects comprises of investments and consultancy work mainly in solar power plants and hydro power. We provide financial cash flow reports with the return on Investment.'
					description2='We assess the viability and profitability of the project together with our international network. PPI work towards providing initial funding on these green initiative which are carry out especially in developing countries such as India, Cambodia, Myanmar and Vietnam. '
					description3='PPI work towards providing initial funding on these green initiative which are carry out especially in developing countries such as India, Cambodia, Myanmar and Vietnam. '
				/>
				<IndustryIndividualCard
					link = '#'
					clickable={false}
					image={oil}
					title='OIL & GAS'
					description1='The ever-growing correlation between energy products, commodities and financial services has brought forth opportunities for us in this region.'
					description2='Our PPI’s team of coordinators work round the clock to deliver all the physical and financial supports that enable the realization of sizeable transactions in the different continents.'
					description3='PPI is willing to provide access to credit and investment agreements with energy and commodity producers to provide financing for long or short-term transactions. '
				/>
				</div>
			</div>
		);
	}
}
